import React, {useContext} from 'react';
import {Link, useHistory} from "react-router-dom";
import {GlobalContext} from "global-context";
import './header-tools.scss';

export function HeaderTools() {
  const globalContext = useContext(GlobalContext);
  const history = useHistory();

  function logOut() {
    globalContext.logout();
  }

  return (
      <div className='col-12 col-md-9 d-none d-md-block text-right'>
        <div className="dropdown">
          <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Settings
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {globalContext.user.token &&
            <>
                <Link className="dropdown-item" to="/admin">Control Panel</Link>
                <Link className="dropdown-item" to="/admin/node-editor">Node Editor</Link>
            </>
            }
            {globalContext.user.token
                ? <span className="dropdown-item cursor-pointer" onClick={() => logOut()}>Log Out</span>
                : <Link className="dropdown-item cursor-pointer" to="/login">Log In</Link>
            }
          </div>
        </div>
      </div>
  )
}